<template>
  <div class="p-8 flex bg-white">
    <div class="w-6/12 lg:mr-4 mt-2">
      <div class="p-2 bordb flex justify-between items-center w-full">
        <h3 class="text-primary fsize20 font-semibold">Performance</h3>
        <feather-icon
          icon="RefreshCwIcon"
          svgClasses="w-5 h-5"
          @click="reloadIframe"
        />
      </div>
      <div
        class="py-4 px-2 bg-white"
        v-for="(item, index) in RSUData"
        :key="'item -' + index"
      >
        <h1 class="fsize16 mb-2 font-semibold text-dark">
          {{ item.mediatype }}
        </h1>
        <iframe
          :src="item.url"
          class="w-full"
          height="250"
          id="reload"
          :key="reload"
          style="border: 0"
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
    <div class="w-6/12 p-4 shadow bg-fas rounded-16px">
      <div class="p-2 bordb flex justify-between items-center w-full">
        <h3 class="text-primary fsize20 font-semibold">Storage</h3>
      </div>
      <div class="p-3">
        <div class="w-full">
          <h1 class="fsize14 mb-2 text-gray">DB Consumption</h1>
          <div class="w-full grid grid-cols-2">
            <div class="p-2 bg-fas border">
              <h4 class="fsize14 font-bold text-dark">Database name</h4>
            </div>
            <div class="p-2 bg-white border">
              <p class="fsize14 font-medium text-dark">{{ DBData.db }}</p>
            </div>
          </div>
          <div class="w-full grid grid-cols-2">
            <div class="p-2 bg-fas border">
              <h4 class="fsize14 font-bold text-dark">Total Collections</h4>
            </div>
            <div class="p-2 bg-white border">
              <p class="fsize14 font-medium text-dark">
                {{ DBData.collections }}
              </p>
            </div>
          </div>
          <div class="w-full grid grid-cols-2">
            <div class="p-2 bg-fas border">
              <h4 class="fsize14 font-bold text-dark">Data size</h4>
            </div>
            <div class="p-2 bg-white border">
              <p class="fsize14 font-medium text-dark">
                {{ formatBytes(DBData.dataSize) }}
              </p>
            </div>
          </div>
          <div class="w-full grid grid-cols-2">
            <div class="p-2 bg-fas border">
              <h4 class="fsize14 font-bold text-dark">Storage size</h4>
            </div>
            <div class="p-2 bg-white border">
              <p class="fsize14 font-medium text-dark">
                {{ formatBytes(DBData.storageSize) }}
              </p>
            </div>
          </div>
          <div class="w-full grid grid-cols-2">
            <div class="p-2 bg-fas border">
              <h4 class="fsize14 font-bold text-dark">Total size</h4>
            </div>
            <div class="p-2 bg-white border">
              <p class="fsize14 font-medium text-dark">
                {{ formatBytes(DBData.totalSize) }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="p-3">
        <div>
          <h1 class="fsize14 mb-2 text-gray">Cloud Consumption</h1>
          <div class="w-full grid grid-cols-2">
            <div class="p-2 bg-fas border">
              <h4 class="fsize14 font-bold text-dark">Folder Name</h4>
            </div>
            <div class="p-2 bg-fas border">
              <h4 class="fsize14 font-bold text-dark">Storage Used</h4>
            </div>
          </div>
        </div>
        <div class="overtable">
          <div
            class="w-full grid grid-cols-2"
            v-for="(item, index) in storageData"
            :key="'item -' + index"
          >
            <div class="p-2 bg-white border overflow-auto">
              <p class="fsize14 font-medium text-dark">
                {{ item.name }}
              </p>
            </div>
            <div class="p-2 bg-white border">
              <p class="fsize14 font-medium text-dark">
                {{ formatBytes(item.size) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import FeatherIcon from "../../../../../../../components/FeatherIcon.vue";

export default {
  components: { FeatherIcon },
  data() {
    return {
      reload: 0,
    };
  },
  methods: {
    async getData() {
      await this.$store.dispatch("RSU/getResource");
      await this.$store.dispatch("RSU/getStorageData");
      await this.$store.dispatch("RSU/getDBData");
    },
    formatBytes(bytes, decimals = 2) {
      if (!+bytes) return "0 Bytes";
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    },
    async reloadIframe() {
      this.reload += 1;
    },
    // async autoLogin() {
    //   var axios = require("axios").default;
    //   let username = "test@123";
    //   let password = "Test@123";

    //   let data = {
    //     user: username,
    //     password: password,
    //   };
    //   await axios
    //     .post("https://insights.aiab.in/api/auth/login", data)
    //     .then(async function (response) {
    //       console.log(response, "auto login response");
    //     })
    //     .catch(function (error) {
    //       console.error(error, "auto login error");
    //     });

    //   //////////////////////////////////////////
    //   GrafanaEmbed = {
    //     grafanaUrl: "https://your.grafana.example.com",
    //     dashboard: "dashboad-name",
    //     queryParams: {
    //       dashnav: 0,
    //       // this is a base64-encoded string of username:password
    //       // for example on a *NIX machine (and Mac OS X):
    //       // $ echo "kiosk1:supersecret" | base64
    //       // a2lvc2sxOnN1cGVyc2VjcmV0Cg==
    //       auth: "a2lvc2sxOnN1cGVyc2VjcmV0Cg==",
    //       theme: "light",
    //     },
    //   };
    //   (function () {
    //     var d = document.createElement("script");
    //     d.type = "text/javascript";
    //     d.async = true;
    //     d.src =
    //       GrafanaEmbed.grafanaUrl + "/public/app/features/dashboard/embed.js";
    //     (
    //       document.getElementsByTagName("head")[0] ||
    //       document.getElementsByTagName("body")[0]
    //     ).appendChild(d);
    //   })();
    // },
  },
  computed: {
    ...mapState("RSU", ["RSUData", "DBData", "storageData"]),
  },
  mounted() {
    this.getData();
    // this.autoLogin();
  },
};
</script>
